<template>
  <section class="accessories">
    <h2 class="text-center">{{header}}</h2>
    <h3 class="text-center" style="margin-bottom: 2rem">{{subheader}}</h3>

    <AccessoryProduct
      v-if="!hide_phone_mount"
      title="Phone + Arsenal 2 Mount"
      description="Mount Arsenal 2 and your phone on your camera’s hot shoe."
      thumbnail="phone-mount-thumb.jpg"
      most_popular="true"
      :retail_price="order.product_prices ? order.product_prices.phone_mount.retail : prices.phone_mount.retail"
      :sale_price="order.product_prices ? order.product_prices.phone_mount.sale : prices.phone_mount.sale"
      :quantity="order.products.phone_mount.quantity"
      :min_limit="prevent_refunds ? order.products.phone_mount.quantity : 0"
      v-on:update_quantity="order.products.phone_mount.quantity = $event"
    >
      <h3>Phone + Arsenal Mount</h3>
      <img :src="require(`app/assets/images/phone-mount-large.jpg`)" />
      <p>
        Features like panorama really benefit from using your phone as a
        "heads up display". Our new mount holds your phone and Arsenal 2
        securely, making it easy to check your panoramas as they are shot.
      </p>

      <p>
        Supports phones 58mm - 86.5mm wide.  Does not support foldable phones.
      </p>
    </AccessoryProduct>
    <AccessoryProduct
      v-if="(order.products.battery.quantity > 0 || continental_usa) && !hide_power_bank"
      title="USB Powerbank"
      description="An external battery to charge Arsenal and your phone. Great for long timelapses!"
      thumbnail="powerbank-thumb.jpg"
      :retail_price="order.product_prices ? order.product_prices.battery.retail : prices.battery.retail"
      :sale_price="order.product_prices ? order.product_prices.battery.sale : prices.battery.sale"
      :quantity="order.products.battery.quantity"
      :min_limit="prevent_refunds ? order.products.battery.quantity : 0"
      v-on:update_quantity="order.products.battery.quantity = $event"
    >
      <h3>USB Powerbank</h3>
      <img :src="require(`app/assets/images/usb-powerbank-large.jpg`)" />
      <p>
        We designed a power bank that gives you everything you need for long timelapses. Charge Arsenal, your phone, or any other usb device.<br />
        <span class="bold">Specs:</span>
      </p>
      <ul>
        <li>10,000 mAH Battery</li>
        <li>Input: USB-C and USB Micro B (9V/2A, 5V/2A)</li>
        <li>Output: USB-C (1x) and USB-A (2x)<br />(5V/3A, 9V/2A, 12V/1.5A)</li>
      </ul>
    </AccessoryProduct>
    <AccessoryProduct
      v-if="!hide_micro_sd_card"
      title="Sandisk Micro SD Card (128GB)"
      description="Save stacked photos, panoramas, Deep Color photos and more."
      thumbnail="sandisk.jpg"
      :retail_price="order.product_prices ? order.product_prices.micro_sd_card.retail : prices.micro_sd_card.retail"
      :sale_price="order.product_prices ? order.product_prices.micro_sd_card.sale : prices.micro_sd_card.sale"
      :quantity="order.products.micro_sd_card.quantity"
      :min_limit="prevent_refunds ? order.products.micro_sd_card.quantity : 0"
      v-on:update_quantity="order.products.micro_sd_card.quantity = $event"
    >
      <h3>Sandisk Extreme Pro A2 Micro SD Card (128GB)</h3>
      <p>By using a Micro SD card with Arsenal 2, you can:</p>
      <ul>
        <li>
          Save stacked photos, panoramas, and Deep Color photos as JPG or
          16-bit DNGs
        </li>
        <li>Save timelapses as 1080p h.264 videos</li>
        <li>
          Immediately make an extra backup of photos, for those single card
          slot cameras
        </li>
        <li>Read Speed: 200MB/s, Write Speed: 90MB/s</li>
      </ul>
      <p class="bold">Size: 128GB</p>
    </AccessoryProduct>
  </section>
</template>

<script>
  import AccessoryProduct from "app/components/orders/AccessoryProduct";

  /*
    NB: Only show the power pack if the user has a) already purchased it, or b) is in the continental USA
    Since it has to be shipped separately and is too expensive to ship internationally or even to HA/AK
  */

  export default {
    props: ["header", "subheader", "order", "prices", "$v", "prevent_refunds", "continental_usa", "hide_phone_mount", "hide_power_bank", "hide_micro_sd_card"],
    data() {
      return { arsenal_added: false };
    },
    components: { AccessoryProduct },
  }
</script>
